// 404 Not Found Component
// Displays when a route doesn't exist

import { useLocation } from 'react-router-dom';
import { useNavigationManager } from '../core';

export function NotFound() {
  const location = useLocation();
  const navigationManager = useNavigationManager();

  const handleGoHome = async () => {
    await navigationManager.goHome();
  };

  const handleGoBack = async () => {
    await navigationManager.goBack();
  };

  return (
    <div className="not-found">
      <div className="not-found-content">
        <div className="error-code">404</div>
        <h1 className="error-title">Page Not Found</h1>
        <p className="error-message">
          The page <code className="error-path">{location.pathname}</code> doesn't exist or has been moved.
        </p>

        <div className="error-actions">
          <button className="btn btn-primary" onClick={handleGoHome}>
            Go Home
          </button>
          <button className="btn btn-secondary" onClick={handleGoBack}>
            Go Back
          </button>
        </div>
      </div>
    </div>
  );
}
